import { Authnz } from "capitalrx-components";

import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";

export interface UserPermissionsGetState {
  actions: Array<string>;
  loading: boolean;
}

const DEFAULT_USER_PERMISSIONS_GET_STATE: UserPermissionsGetState = {
  actions: [],
  loading: false,
};

export default (state: UserPermissionsGetState = DEFAULT_USER_PERMISSIONS_GET_STATE, action: Action | Authnz.Action): {} => {
  if (action.type === ActionTypes.GET_USER_PERMISSIONS) {
    return {
      ...state,
      loading: true,
    };
  } else if (action.type === ActionTypes.GET_USER_PERMISSIONS_RESULTS) {
    return {
      actions: action.payload.actions,
      loading: false,
    };
  } else if (action.type === Authnz.ActionTypes.AUTHNZ_USER_LOG_OUT) {
    return {
      ...state,
      actions: [],
    };
  } else {
    return state;
  }
};
